import { useEffect, useState } from "react";
import { injectIntl } from "react-intl";

const CancelSchedule = (props) => {
  const [selectedReason, setSelectedReason] = useState(null);
  const [otherDescription, setOtherDescription] = useState("");
  const [cancellationReasons, setCancellationReasons] = useState([]);

  useEffect(() => {
    if (props.item?.status === "DONE") {
      setCancellationReasons([
        "Content needs revision",
        "Wrong audience selected",
        "Technical issue",
        "Other",
      ]);
    } else {
      setCancellationReasons([
        "Content needs revision",
        "Wrong audience selected",
        "Timing is not suitable",
        "Low expected performance",
        "Technical issue",
        "Other",
      ]);
    }
  }, [props]);

  return (
    <div className="NewStrategyModalOverlay">
      <div className="DeleteCalendarModal">
        <div className="w-full flex flex-col items-start gap-3 self-stretch">
          <div className="flex justify-between self-stretch">
            <div className={"DeleteCalendar"}>
              <img
                alt={"Logo"}
                src={"/media/icons/alert-triangle.svg"}
                className={"w-[18px] h-[18px]"}
              />
              Cancel Scheduled Offer?
            </div>
            <button className={"CloseIconButton"} onClick={props.close}>
              <img
                alt={"Logo"}
                src={"/media/icons/closeIcon.svg"}
                className={"w-5 h-5"}
              />
            </button>
          </div>
          <div className="DeleteScheduleContent">
            <div className={"flex gap-1 items-center"}>
              <img
                alt={"Logo"}
                src={"/media/icons/rows.svg"}
                className={"w-[14px] h-[14px]"}
              />
              <div className={"DashboardListNameTitle min-w-[95px]"}>
                List Name:
              </div>
              <div className={"SMSEmailBoxListName"}>
                {props.item?.list_id?.name}
              </div>
            </div>
            <div className={"HorizontalDivider"}></div>
            <div className={"flex gap-1 items-center"}>
              <img
                alt={"Logo"}
                src={"/media/icons/offer.svg"}
                className={"w-[14px] h-[14px]"}
              />
              <div className={"DashboardListNameTitle min-w-[95px]"}>
                Offer Name:
              </div>
              <div className={"flex gap-3"}>
                <div className={"SMSEmailBoxListName"}>
                  {props.item?.offer_id?.name}
                </div>
              </div>
            </div>
            <div className={"HorizontalDivider"}></div>
            <div className={"flex gap-1 items-center"}>
              <img
                alt={"Logo"}
                src={"/media/icons/creative.svg"}
                className={"w-[14px] h-[14px]"}
              />
              <div className={"DashboardListNameTitle min-w-[95px]"}>
                Creative Name:
              </div>
              <div className={"flex gap-3"}>
                <div className={"SMSEmailBoxListName"}>
                  {props.item?.creative_id?.name}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="DeleteScheduleSection">
          <div className="DeleteScheduleBodyText">
            This offer will be cancelled before its scheduled send time.
            Cancelled offers will not be delivered and no performance data will
            be generated.
            <br />
            <br /> Please let us know the reason for cancellation.
          </div>
          <div className={"HorizontalDivider"}></div>
          <div className="flex items-start self-stretch gap-4">
            <div className="text-[#171717] font-sans text-xs font-semibold leading-normal min-w-[120px]">
              Cancellation Reason
            </div>
            <div className="flex flex-col items-start gap-[18px] w-full">
              {cancellationReasons.map((reason) => (
                <div
                  key={reason}
                  className={
                    reason === "Other"
                      ? "flex flex-col items-start gap-3 self-stretch w-full"
                      : "flex items-center gap-[6px]"
                  }
                >
                  <div
                    className="flex items-center gap-[6px] cursor-pointer"
                    onClick={() => setSelectedReason(reason)}
                  >
                    <div
                      className={
                        selectedReason === reason
                          ? "CheckedRadioButton"
                          : "RadioButton"
                      }
                    />
                    <div className="text-[#15151F] font-sans text-xs font-medium leading-[14px]">
                      {reason}
                    </div>
                  </div>
                  {reason === "Other" && selectedReason === "Other" && (
                    <textarea
                      className="DeleteScheduleTextarea w-full"
                      placeholder="You may add additional details about the cancellation"
                      rows={4}
                      value={otherDescription}
                      onChange={(e) => setOtherDescription(e.target.value)}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className={"HorizontalDivider"}></div>
          <div className="flex justify-end self-stretch items-start gap-3">
            <button
              className="DeleteScheduleSecondaryButton"
              onClick={props.close}
            >
              Keep{" "}
              {props.item?.status === "DONE" ? "as Completed" : "Scheduled"}
            </button>
            <button
              className="PrimaryButton"
              onClick={() => {
                const isDeleteByDate =
                  props.submitWithReason === false &&
                  props.calendars?.length > 0;
                if (isDeleteByDate) {
                  props.deleteSchedule(props.calendars[0].date);
                  return;
                }
                if (!selectedReason) return;
                const cancel_reason_title = selectedReason;
                const cancel_reason_description =
                  selectedReason === "Other" ? otherDescription : "";
                props.deleteSchedule({
                  cancel_reason_title,
                  cancel_reason_description,
                });
              }}
              disabled={
                (props.submitWithReason !== false ||
                  !(props.calendars?.length > 0)) &&
                !selectedReason
              }
            >
              Cancel Offer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(CancelSchedule);
